import React from "react";
import { Container } from "react-bootstrap";
import { FaHeadset } from "react-icons/fa";
import { FiTruck } from "react-icons/fi";
import { BsCashCoin,BsArrowReturnLeft } from "react-icons/bs";
import './OurFeature.css'
const OurFeatures = () => {
  return (
    <div className="section-container our-feature pt-5">
      <Container>
        <div className="row pb-5">
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 p-0">
            <div className="our-feature-container text-center border-0 border-1 border-end">
              <div className="our-feature-icon mb-3">
                <FiTruck className="fs-2"/>
              </div>
                <h5 className="fw-light">Free Shipping</h5>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 p-0">
            <div className="our-feature-container text-center border-0 border-1 border-end">
              <div className="our-feature-icon mb-3">
                <BsCashCoin className="fs-2"/>
              </div>
                <h5 className="fw-light">Secure Payments</h5>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 p-0">
            <div className="our-feature-container text-center border-0 border-1 border-end">
              <div className="our-feature-icon mb-3">
                <BsArrowReturnLeft className="fs-2"/>
              </div>
                <h5 className="fw-light">Free Return</h5>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 p-0">
            <div className="our-feature-container text-center border-0">
              <div className="our-feature-icon mb-3">
                <FaHeadset className="fs-2"/>
              </div>
                <h5 className="fw-light">24/7h Support</h5>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default OurFeatures;
